<template>
  <div class="row">
    <div class="col-md-6">
      <template v-for="(level1, level1id) in jsonstartquestion.level1">
        <div class="alert alert-warning" :key="level1id">
          {{ level1.name }}
        </div>
        <template v-for="(level2, level2id) in level1.level2">
          <div class="alert alert-info" :key="level2id">
            {{ level2.name }}
          </div>
          <div
            class="well"
            v-for="(quest, questid) in level2.question"
            :key="questid"
          >
            <strong>{{ quest.val }}</strong>
            
            <div
              class="form-group clearfix"
              v-for="(answer, answerid) in quest.answers"
              :key="answerid"
            >
              <input
                :name="'pole_' + level1id + level2id + questid"
                :id="'pole_' + level1id + level2id + questid + answerid"
                type="radio"
                :value="answer.id"
                v-model="quest.now"
              />
              <label
                class="form-control btn btn-info"
                :for="'pole_' + level1id + level2id + questid + answerid"
                >{{ answer.val }}</label
              >
            </div>
          </div>
        </template>
      </template>
      <button class='form-control btn btn-info' @click='startnewsave();'>Сохранить</button>
      <template v-for="(level1, level1id) in jsonquestion.level1">
        <div class="alert alert-warning" :key="level1id">
          {{ level1.name }}
        </div>
        <template v-for="(level2, level2id) in level1.level2">
          <div class="alert alert-info" :key="level2id">
            {{ level2.name }}
          </div>
          <div
            class="well"
            v-for="(quest, questid) in level2.question"
            :key="questid"
          >
            <strong>{{ quest.val }}</strong>
            
            <div
              class="form-group clearfix"
              v-for="(answer, answerid) in quest.answers"
              :key="answerid"
            >
              <input
                :name="'pole_' + level1id + level2id + questid"
                :id="'pole_' + level1id + level2id + questid + answerid"
                type="radio"
                :value="answer.id"
                v-model="quest.now"
              />
              <label
                class="form-control btn btn-info"
                :for="'pole_' + level1id + level2id + questid + answerid"
                >{{ answer.val }}</label
              >
            </div>
          </div>
        </template>
      </template>
      <button class='form-control btn btn-info' @click='newsave();'>Сохранить</button>
    </div>
    <div class="col-md-6">
      <img v-for="img in json" :src="img" :key="img" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import nprogress from "nprogress";

export default {
  created: function () {
    this.getfoto();
    this.startanketload();
    this.getanketinfo();
    this.newanketLoad();
  },
  methods: {
    startanketload: function(){
      nprogress.start();
      axios({
        withCredentials: true,
        url:
          "http://eduqa.egechita.ru/back/getstartquestionforeduexpertansket/" +
          this.$route.params.id,
        withCredentials: true,
        method: "get",
      }).then(Response => {
        this.jsonstartquestion = Response.data
         nprogress.done();
        });
    },

    newanketLoad: function(){
      nprogress.start();
      axios({
        withCredentials: true,
        url:
          "http://eduqa.egechita.ru/back/getquestionforeduexpertanket/" +
          this.$route.params.id,
        withCredentials: true,
        method: "get",
      }).then(Response => {
        this.jsonquestion = Response.data
         nprogress.done();
        });
    },
    getanketinfo: function () {
      nprogress.start();
      axios({
        url:
          "http://eduqa.egechita.ru/back/experteduanketinfoanswer/" +
          this.$route.params.id,
        withCredentials: true,
        method: "get",
      }).then((Response) => {
        nprogress.done();
        if (Response.data.isset == 1) {
          this.answers = Response.data.info;
        }
      });
    },
     newsave: function () {
      nprogress.start();
      axios({
        data: this.jsonquestion,
        url:
          "http://eduqa.egechita.ru/back/saveexperteduanket2/" +
          this.$route.params.id,
        withCredentials: true,
        method: "POST",
      }).then((Response) => {
        nprogress.done();
        //this.json = Response.data
      });
    },
    startnewsave: function () {
      nprogress.start();
      axios({
        data: this.jsonstartquestion,
        url:
          "http://eduqa.egechita.ru/back/startsaveexperteduanket2/" +
          this.$route.params.id,
        withCredentials: true,
        method: "POST",
      }).then((Response) => {
        nprogress.done();
        this.jsonquestion = {};
        this.newanketLoad();
        //this.json = Response.data
      });
    },
    sendData: function () {
      nprogress.start();
      axios({
        data: this.answers,
        url:
          "http://eduqa.egechita.ru/back/saveexperteduanket/" +
          this.$route.params.id,
        withCredentials: true,
        method: "POST",
      }).then((Response) => {
        nprogress.done();
        //this.json = Response.data
      });
    },
    getfoto: function () {
      nprogress.start();
      axios({
        url:
          "http://eduqa.egechita.ru/back/expertfoto/" + this.$route.params.id,
        withCredentials: true,
      }).then((Response) => {
        nprogress.done();
        this.json = Response.data;
      });
    },
  },
  data() {
    return {
      json: [],
      answers: [],
      jsonquestion: {},
      jsonstartquestion: {},
    
    };
  },
};
</script>
<style scoped>
input[type="radio"]:checked + label.btn {
  background-color: rgb(24, 218, 201);
}
input[type="radio"] {
  display: none;
}
</style>

